import styled from 'styled-components';
import { CloseIcon } from '@/icons/index';
import { StyledH3, StyledH4, StyledP } from '@/Shared/Typography/typography';
import { media } from '@/Shared/theme';

export const StyleMobileAlert = styled.div`
	background-color: hsla(0, 0%, 100%, 0.95);
	bottom: 0;
	display: flex;
	left: 0;
	padding: var(--spacing-10);
	position: absolute;
	right: 0;
	top: 0;
	z-index: 100;

	${media.smallScreen} {
		display: none;
	}

	div {
		margin: auto;
		max-width: 500px;
	}

	img {
		max-width: 400px;
	}

	${StyledP} {
		font-size: 2rem;
		max-width: 400px;
	}
`;

export const StyledBanner = styled.div<{ image: string }>`
	background-color: var(--org-color);
	background-image: ${(props) => `url(${props.image})`};
	background-position: center;
	background-size: cover;
	display: flex;
	flex-shrink: 0;
	min-height: 200px;
	outline: 0;
	position: relative;

	&.is-full-screen {
		display: none;
	}

	.overlay {
		background-color: #0b0201;
		height: 100%;
		inset: 0;
		opacity: 0.6;
		position: absolute;
		width: 100%;
	}

	.wrap {
		color: var(--neutral-50);
		margin: auto;
		max-width: 800px;
		padding: var(--spacing-4);
		position: relative;
		width: 100%;

		${StyledH3} {
			margin-bottom: var(--spacing-4);
		}

		p {
			font-size: 1.7rem;
		}

		* {
			color: var(--neutral-50);
		}
	}
`;

export const StyledCourseAlignmentWrap = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-bottom: var(--spacing-4);

	${media.smallScreen} {
		overflow: hidden;
		padding-left: var(--spacing-4);
	}
`;

export const StyledContent = styled.div`
	display: flex;
	height: calc(100% - 92px);
	position: relative;
	width: 100%;
	z-index: 10;

	.tagline {
		background-color: var(--neutral-50);
		border-radius: 6px 6px 0 0;
		color: var(--org-color);
		font-size: 2rem;
		line-height: 1.3;
		margin-bottom: 0;
		padding: 0 var(--spacing-6) var(--spacing-6);
	}
`;

export const StyledSidebar = styled.div`
	background-color: var(--neutral-50);
	box-shadow: 0 3px 8px 0 rgb(0 0 0 / 10%);
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	flex: 0 0 250px;
	height: calc(100vh - 52px);
	overflow: auto;
	padding-top: var(--spacing-8);
	position: relative;
	z-index: 10;

	${media.condensed} {
		flex: 0 0 400px;
		padding-top: 0;
	}

	.legend-mission {
		background-color: var(--org-color);
		display: none;
		margin-bottom: var(--spacing-8);
		padding: var(--spacing-10) var(--spacing-6) var(--spacing-4);
		position: relative;
		/* background-image: url(https://res.cloudinary.com/stakk-io/image/upload/v1618067919/park-tudor/course-map/course-map-hero_m4iffv.jpg); */
		background-position: center;
		background-size: cover;
		position: relative;

		${media.condensed} {
			display: block;
		}

		${StyledH4},
		${StyledP} {
			color: var(--c-white);
			position: relative;
		}

		.overlay {
			background-color: #0b0201;
			bottom: 0;
			height: 100%;
			left: 0;
			opacity: 0.6;
			position: absolute;
			right: 0;
			top: 0;
			width: 100%;
		}
	}
`;

export const StyledLegend = styled.div`
	padding: 0 var(--spacing-6) 0;

	strong {
		color: var(--body-text);
		display: inline-block;
		font-family: var(--font-semibold);
		margin-bottom: var(--spacing-4);
	}

	.legend-item {
		align-items: center;
		color: var(--body-text);
		display: flex;
		margin-bottom: var(--spacing-2);

		&:last-of-type {
			margin-bottom: 0;
		}
	}

	.discipline-wrap {
		padding-bottom: var(--spacing-6);
	}

	.divisions-wrap {
		padding-bottom: var(--spacing-2);
	}

	.letter-indicator {
		align-items: center;
		border-radius: 50%;
		color: rgb(166, 159, 136);
		display: flex;
		font-family: var(--font-semibold);
		font-size: 2rem;
		height: 25px;
		justify-content: center;
		margin-right: var(--spacing-2);
		text-align: center;
		user-select: none;
		width: 25px;
	}

	.color-indicator {
		border-radius: 50%;
		flex-shrink: 0;
		height: 25px;
		margin-right: var(--spacing-2);
		width: 25px;
	}
`;

export const StyledBG = styled.div`
	/* random squares */
	background-attachment: fixed;
	background-color: #ffffff;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' opacity='0.2' stroke-width='0.4' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%23A69F88'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%239f9e9e'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(17.2) translate(-941.86 -706.4)'%3E%3Cg fill='%239f9e9e'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
	background-size: cover;
	bottom: 0;
	left: 0;
	padding: 0 30px;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
	z-index: -1;
`;

export const StyledPanel = styled.div`
	background-color: var(--panel-color);
	bottom: 0;
	box-shadow: -4px 0px 8px rgba(0, 0, 0, 0.15);
	height: 100%;
	position: absolute;
	right: 0;
	top: 0;
	width: 520px;

	.svg-loader {
		margin: auto;
	}

	.wrapper {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
	}

	.course-panel-header {
		margin: var(--spacing-6) var(--spacing-4) var(--spacing-2) var(--spacing-6);
	}

	.course-title {
		max-width: 85%;
	}

	.date {
		color: var(--body-text);
		display: inline-block;
		font-size: 1.2rem;
		font-style: italic;
		margin: 0 var(--spacing-4) var(--spacing-4) 0;
	}

	.tab-group {
		margin: 0 var(--spacing-4) 4px var(--spacing-4);

		button {
			background: none;
			border: none;
			color: var(--org-color);
			margin-right: var(--spacing-2);
			padding: var(--spacing-2);
			opacity: 0.8;

			&:hover {
				box-shadow: 0 3px 0px -1px var(--org-color);
				opacity: 1;
			}

			&:focus-visible {
				outline-color: var(--tab-outline-color);
				outline-style: dotted;
				outline-width: 1px;
				opacity: 1;
			}

			&.active {
				box-shadow: 0 3px 0px 0px var(--org-color);
				opacity: 1;
			}
		}
	}

	.tab-content {
		background-color: var(--map-panel-body);
		height: 100%;
		overflow-y: scroll;
		padding-top: var(--spacing-8);
		width: 100%;
	}

	.panel-content {
		margin: 0 var(--spacing-8) var(--spacing-10);

		&::empty {
			margin: 0;
		}

		p br:last-of-type {
			display: none;
		}

		p,
		span:not(.tagged-word) {
			color: var(--body-text) !important;
			margin-bottom: var(--spacing-4);
		}

		.line-descriptors {
			margin-bottom: 0;
		}

		a {
			align-items: center;
			color: var(--org-color);
			display: inline-flex;
			transition: box-shadow 0.3s;

			&:hover,
			&:focus {
				box-shadow: 0px 2px var(--org-color);
			}

			svg {
				margin-left: 4px;
			}
		}

		ul,
		ol {
			display: block;
			margin-block-start: 1em;
			margin-block-end: 1em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			padding-inline-start: 40px;
			unicode-bidi: isolate;
			list-style-type: disc;
		}
	}

	.tags-wrapper {
		margin-bottom: var(--spacing-8);
		div {
			margin-bottom: var(--spacing-2);
		}
	}
`;

export const StyledCloseIcon = styled(CloseIcon as any)`
	right: 12px;
	top: var(--spacing-4);
	transition: background-color 0.3s;
	z-index: 1;

	&:hover,
	&:focus {
		background-color: var(--org-color);

		svg {
			fill: var(--neutral-50);
		}
	}

	svg {
		transition: fill 0.2s;
		width: 16px;
	}
`;
